import { bffFetch } from './utils';

type TrackingStatus = 'ALL_ACCEPTED' | 'ALL_DENIED' | 'SOME_ACCEPTED' | 'SOME_DENIED';

type CategoryState = 'ALL_ACCEPTED' | 'ALL_DENIED' | 'GRANULAR' | 'NO_INTERACTION';

export interface TrackingService {
  name: string;
  version: string;
  category: string;
  essential: boolean;
  consent: {
    given: boolean;
  };
}

export interface TrackingCategory {
  dps: Record<string, boolean>;
  essential: boolean;
  state: CategoryState;
}

export interface TrackingConsentDataV1 {
  controllerId: string;
  /**
   * Unix timestamp in milliseconds. Comes from Usercentrics.
   */
  timestamp: string;
  status: TrackingStatus;
  services: Record<string, TrackingService>;
  categories: Record<string, TrackingCategory>;
  categoryLookup: { label: string; slug: string }[];
}

const updateTrackingMutation = (variables: { trackingConsentsData: string }) => ({
  operationName: 'updateTrackingConsents',
  query: `mutation updateTrackingConsents($trackingConsentsData: JSONString!) {
  updateTrackingConsents(trackingConsentsData: $trackingConsentsData) {
    __typename
    ... on UpdateTrackingConsentStatus {
      ...updateTrackingConsentStatusFields
    }
    ... on MissingPushTokenError {
      _
    }
  }
}

  fragment updateTrackingConsentStatusFields on UpdateTrackingConsentStatus {
    message
  }`,
  variables,
});

export const updateUserTracking = async (trackingConsentData: TrackingConsentDataV1) => {
  const variables = { trackingConsentsData: JSON.stringify(trackingConsentData) };

  return await bffFetch<{ message?: string }>(updateTrackingMutation(variables));
};

export const trackingConsentsField = `
  trackingConsents {
    __typename
    ... on TrackingConsentMappingV1 {
      ...trackingConsentMappingV1Fields
    }
    ... on MissingPushTokenError {
      _
    }
  }`;

export const trackingConsentsFieldFragment = `
  fragment trackingConsentMappingV1Fields on TrackingConsentMappingV1 {
    controllerId
    accountId
    ecommerceId
    timestamp
  }`;

const trackingConsentsQuery = {
  operationName: 'trackingConsents',
  query: `query trackingConsents {
    ${trackingConsentsField}
  }

  ${trackingConsentsFieldFragment}`,
};

export interface TrackingConsentMappingV1 {
  controllerId: string;
  accountId: string;
  ecommerceId: string;
  /**
   * Stringified unix timestamp in milliseconds
   */
  timestamp: string;
}

export const getUserTrackingConsents = async () => {
  return await bffFetch<{ trackingConsents: TrackingConsentMappingV1 | null }>(
    trackingConsentsQuery,
  );
};
